// extracted by mini-css-extract-plugin
module.exports = {"overflow-hidden-container":"playspace_overflow-hidden-container__3senx"};